import moment from 'moment';

export default (month, year, today = moment()) => {
  if (!month || !year) {
    return true;
  }
  return moment(`${year}-${month}-01`, 'Y-M-D').endOf('month').isAfter(today);
};
